import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-header",
    styleUrls: ["./header.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./header.component.html"
})
export class HeaderComponent {
    @Input() uppercase = false;
    @Input() size = "2";
    @Input() noPadding = "";

}
